import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

import AuthenticatedApp from "./pages/authenticatedApp";

const App: React.FC = () => {
  return (
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH_0_ENDPOINT!}
      clientId={process.env.REACT_APP_AUTH_0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: process.env.REACT_APP_AUTH_0_AUDIENCE,
      }}
    >
      <AuthenticatedApp />
    </Auth0Provider>
  );
};

export default App;
